export default __webpack_public_path__ + "static/media/023-necklace.5bda8cf0.svg";